import { render, staticRenderFns } from "./chose_class.vue?vue&type=template&id=3585fd4c&scoped=true"
import script from "./chose_class.vue?vue&type=script&lang=js"
export * from "./chose_class.vue?vue&type=script&lang=js"
import style0 from "./chose_class.vue?vue&type=style&index=0&id=3585fd4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3585fd4c",
  null
  
)

export default component.exports